// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-vault-deployer-api';

export const useDeployVault: typeof hookExports.useDeployVault = hookExports.useDeployVault;
export const useAddDeployer: typeof hookExports.useAddDeployer = hookExports.useAddDeployer;
export const useFindDeployer: typeof hookExports.useFindDeployer = hookExports.useFindDeployer;
export const useLazyFindDeployer: typeof hookExports.useLazyFindDeployer =
  hookExports.useLazyFindDeployer;
export const useGetDeployer: typeof hookExports.useGetDeployer = hookExports.useGetDeployer;
export const useLazyGetDeployer: typeof hookExports.useLazyGetDeployer =
  hookExports.useLazyGetDeployer;
export const useWithdrawGas: typeof hookExports.useWithdrawGas = hookExports.useWithdrawGas;
